// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-list-view .video-list-info .video-img{width:100%;padding:.3125rem 0 .3125rem 0}.video-list-view .video-label{padding:0 .3125rem 0 .3125rem;font-family:Arial,Helvetica,\"sans-serif\"}.video-list-view .video-hr{margin:.3125rem .3125rem .0625rem .3125rem}", ""]);
// Exports
module.exports = exports;
